import { datetime } from '../DateTime';

const lang = $('html').data('lang') || $('html').attr('lang');

export function calendarTranslations() {
    return {
        previousMonth: window.traductionBM?.previousMonth || 'Previous month',
        nextMonth: window.traductionBM?.nextMonth || 'Next month',
        weekdays: datetime().weekdays().map(function (weekday) {
            return weekday.charAt(0).toUpperCase() + weekday.slice(1);
        }),
        weekdaysShort: datetime().weekdaysShort().map(function (weekday) {
            return weekday.charAt(0).toUpperCase() + weekday.slice(1).replace('.', '');
        }),
        months: datetime().months().map(function (month) {
            return month.charAt(0).toUpperCase() + month.slice(1);
        }),
        monthsShort: datetime().monthsShort().map(function (month) {
            if (lang === 'th') {
                return month.charAt(0).toUpperCase() + month.slice(1);
            } else {
                return month.charAt(0).toUpperCase() + month.slice(1).replace('.', '');
            }
        }),
        getAll: function () {
            return {
                previousMonth: this.previousMonth,
                nextMonth: this.nextMonth,
                weekdays: this.weekdays,
                weekdaysShort: this.weekdaysShort,
                months: this.months,
                monthsShort: this.monthsShort
            };
        },
        /**
         * Translates month names to current language using the datetime object.
         * If the node has the data attribute `data-use-full-month-name` set, it can
         * be used to have either full or short name for the month.
         */
        translateEntriesMonths: function () {
            const entries = document.querySelectorAll('.blog-entry__date .month');
            entries.forEach(entry => {
                if (!entry.dataset.date || entry.dataset.date === 'false') return;

                const useFullMonthName = parseInt(entry.dataset.useFullMonthName, 10) === 1;
                const d = datetime(entry.dataset.date);
                const newName = useFullMonthName ? d.monthFullName() : d.monthShortName();
                entry.textContent = newName;
            });
        },
        /** from seh-tc-theme */
        translateEntriesShortMonths: function () {
            let i;
            let entries = document.querySelectorAll('.blog-entry__date .month');
            for (i = 0; i < entries.length; ++i) {
                if (entries[i].dataset.date){
                    let d = datetime(entries[i].dataset.date);
                    entries[i].textContent = d.monthShortName();
                }
            }
        }
    };
}